import { render, staticRenderFns } from "./termsOfServiceUS.vue?vue&type=template&id=cd7d9838&scoped=true"
import script from "./termsOfServiceUS.vue?vue&type=script&lang=js"
export * from "./termsOfServiceUS.vue?vue&type=script&lang=js"
import style0 from "./termsOfServiceUS.vue?vue&type=style&index=0&id=cd7d9838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7d9838",
  null
  
)

export default component.exports